var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/partials/account-navigation-links-dashboard.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "\n<li class=\"o-secondary-navigation__li u-extra-small--show u-medium--hide\">\n    <a class=\"o-secondary-navigation__a ";
output += runtime.suppressValue(((runtime.contextOrFrameLookup(context, frame, "helpers") && (lineno = 2, colno = 113, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "helpers")),"urlContains"), "helpers[\"urlContains\"]", context, ["dashboard"])))?"o-secondary-navigation__a--current":""), env.opts.autoescape);
output += "\" href=\"";
output += runtime.suppressValue((lineno = 2, colno = 155, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "accountUrl"), "accountUrl", context, ["dashboard"])), env.opts.autoescape);
output += "\" data-link-name=\"dashboard\" data-qa-my-account-nav=\"account_navigation-dashboard\">\n        ";
output += runtime.suppressValue((lineno = 3, colno = 9, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["account_navigation-dashboard",runtime.makeKeywordArgs({"state": runtime.contextOrFrameLookup(context, frame, "core")})])), env.opts.autoescape);
output += "\n    </a>\n</li>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/partials/account-navigation-links-dashboard.j2"] , dependencies)